import React from "react";

export const CommonFAQ = [
  {
    title: "Quais são as formas de pagamento permitidas para o Seguro?",
    body: (
      <>
        Você consegue pagar o seguro por débito em conta da Caixa ou por boleto
        bancário.
      </>
    ),
  },
  {
    title: "Quais são as exigências para a renovação automática da apólice?",
    body: (
      <>
        Para a renovação automática da apólice, é necessário que a pessoa
        segurada, ao preencher a proposta, declare por essa escolha e opte pelo
        pagamento via débito em conta Caixa. Além disso, na data da renovação, o
        cliente deve possuir saldo suficiente em sua conta corrente informada,
        para que o valor do seguro seja descontado.
      </>
    ),
  },
  {
    title: "Qual é o prazo para análise do pedido de indenização?",
    body: (
      <>
        A partir do recebimento de todos os documentos, a seguradora possui até
        30 dias corridos para analisar o pedido e apresentar a decisão final.
      </>
    ),
  },
  {
    title:
      "O pedido de indenização foi aprovado, quando o pagamento será liberado?",
    body: (
      <>
        O valor será depositado em até 7 dias úteis, a partir da data de
        conclusão da análise.
      </>
    ),
  },
  {
    title:
      "Não recebi o e-mail com a lista de documentos necessários para a análise do pedido, como faço?",
    body: (
      <>
        <p>
          Verifique a lixeira ou a caixa de spam do seu e-mail. Se não
          encontrar, entre em contato com a gente pelos seguintes canais de
          atendimento
        </p>
        <br />
        <p>
          <strong>Pelo chat - disponível neste site</strong>
          <br />
          De segunda a sexta, das 8h às 21h. Sábados, domingos e feriados, das
          9h às 17h.
        </p>
        <br />
        <p>
          <strong>Telefone 0800 274 1000</strong>
          <br />
          De segunda a sexta, das 8h às 21h, exceto feriados nacionais.
        </p>
      </>
    ),
  },
  {
    title: "Não concordo com a decisão da seguradora, posso recorrer?",
    body: (
      <>
        Sim! Você pode pedir a revisão da análise do pedido. Para isso, deverá
        elaborar uma declaração com os motivos de não concordar com a decisão e
        enviar pra gente pelos mesmos canais de envio da documentação básica.
      </>
    ),
  },
  {
    title: "Quais os serviços oferecidos pela Assistência Dia & Noite?",
    body: (
      <>
        A Assistência Dia & Noite oferece serviços emergenciais em momentos de
        sinistro e indicação e envio de profissionais para pequenos reparos,
        como chaveiro por perda, roubo ou quebra das chaves, chaveiro por roubo
        ou furto do imóvel segurado, serviço de segurança e vigilância,
        hidráulica, eletricista, vidraceiro, transporte de ambulância, entre
        outros.
      </>
    ),
  },
  {
    title:
      "O seguro reembolsa serviços de assistência, como chaveiro, encanador e eletricista, contratados de forma particular?",
    body: (
      <>
        Apenas se a execução do serviço for comunicada antes e autorizada pela
        nossa equipe.
      </>
    ),
  },
  {
    title:
      "Como são as comissões de venda e as participações societárias dos intermediários para o seguro?",
    body: (
      <>
        Nos termos da Resolução CNSP nº 382/2020, a Caixa Seguradora informa que
        a CAIXA, por meio de sua subsidiária integral Caixa Seguridade
        Participações S.A., detém participação societária direta sobre a CNP
        Seguros Holding Brasil S.A., no percentual de 48,25%. A CNP Seguros
        Holding Brasil S.A. remunera seus intermediários em até 35% pela
        comercialização do seu Seguro Empresarial, de acordo com o canal de
        venda.
      </>
    ),
  },
];
